/**
 * 辅导奖记录 — GET /api/admin/mentorship/log
 *
 * Reads UoBalanceLog rows with action='mentorship_bonus', parsed to extract
 * circle depth and source user from the ref field.
 */
import { useState } from 'react';
import { Input, Space, Tag } from 'antd';
import { DataTable } from '../../components/DataTable';

interface MentorRow {
  id: string;
  mentor_id: number;
  asset: string;
  delta: string;
  circle: number | null;
  source_user_id: number | null;
  ref: string;
  note: string | null;
  create_time: string;
}

const CIRCLE_COLOURS: Record<number, string> = {
  1: 'gold',
  2: 'blue',
  3: 'cyan',
  4: 'geekblue',
  5: 'purple',
  6: 'volcano',
  7: 'red',
};

export function MentorshipLogPage() {
  const [mentorId, setMentorId] = useState('');
  const [sourceId, setSourceId] = useState('');

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 120 },
    { title: '时间', dataIndex: 'create_time', width: 170 },
    {
      title: '辅导人 (mentor)',
      dataIndex: 'mentor_id',
      width: 110,
    },
    {
      title: '来源用户',
      dataIndex: 'source_user_id',
      width: 110,
      render: (v: number | null) => v ?? '—',
    },
    {
      title: '圈层',
      dataIndex: 'circle',
      width: 80,
      render: (v: number | null) =>
        v != null ? (
          <Tag color={CIRCLE_COLOURS[v] ?? 'default'}>第 {v} 圈</Tag>
        ) : (
          '—'
        ),
    },
    {
      title: '资产',
      dataIndex: 'asset',
      width: 80,
      render: (v: string) => v.toUpperCase(),
    },
    {
      title: '奖励金额',
      dataIndex: 'delta',
      width: 160,
      render: (v: string) => (
        <span style={{ fontFamily: 'monospace', color: '#16a34a', fontWeight: 600 }}>
          +{v}
        </span>
      ),
    },
    {
      title: '备注',
      dataIndex: 'note',
      ellipsis: true,
      render: (v: string | null) => v ?? '—',
    },
  ];

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>辅导奖记录（辅导奖）</h2>
      <Space style={{ marginBottom: 12 }} wrap>
        <Input
          placeholder="辅导人 ID"
          style={{ width: 150 }}
          value={mentorId}
          onChange={(e) => setMentorId(e.target.value)}
          allowClear
        />
        <Input
          placeholder="来源用户 ID"
          style={{ width: 150 }}
          value={sourceId}
          onChange={(e) => setSourceId(e.target.value)}
          allowClear
        />
      </Space>
      <DataTable<MentorRow>
        queryKey={['admin', 'mentorship-log', mentorId, sourceId]}
        endpoint="/api/admin/mentorship/log"
        extraParams={{
          mentor_id:
            mentorId.trim() && !isNaN(Number(mentorId)) ? Number(mentorId) : undefined,
          source_user_id:
            sourceId.trim() && !isNaN(Number(sourceId)) ? Number(sourceId) : undefined,
        }}
        columns={columns}
        rowKey="id"
        scroll={{ x: 1100 }}
      />
    </div>
  );
}
